import React, { Component } from 'react';
import { connect } from 'react-redux';
import { deleteNode } from '../../actions';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import locale from '../../common/locale'
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export class DeleteButton extends Component {

  constructor(props) {
    super(props);
    this.state = { open: false }
  }

  handleOpen = () => {
    this.setState({ open: true });
  }

  handleClose = () => {
    this.setState({open: false});
  }

  handleDelete = () => {
    this.setState({open: false});
  }

  render() {
    const loc = cookies.get('locale')
    const { id, number, server, deleteNode } = this.props

    if(id in server.children && server.children[id].length > 0) {
      return(
        <MuiThemeProvider>
          <div>
            <div className='button delete'
              onClick={this.handleOpen}
              style={{cursor: 'pointer'}}>
              <i class="fas fa-trash-alt fa-lg" />
            </div>
            <Dialog
              modal={false}
              open={this.state.open}
              onRequestClose={this.handleClose} >
              {locale.cannot_delete_message(loc)}
            </Dialog>
          </div>
        </MuiThemeProvider>
      )
    }

    return(
        <MuiThemeProvider>
          <div className='button delete'
            onClick={this.handleOpen}
            style={{cursor: 'pointer'}}>
            <i class="fas fa-trash-alt fa-lg" />
          </div>
          <Dialog
            modal={false}
            open={this.state.open}
            onRequestClose={this.handleClose} >
            {locale.delete_message(loc)}
            <span style={{margin: '0 50px 0 0'}}></span>
            <FlatButton label={locale.delete(loc)}
              backgroundColor="#5a5a5a"
              style={{color: "#FFF"}}
              onClick={e => { deleteNode(id, number) } }
            />
            <span style={{margin: '0 50px 0 0'}}></span>
            <FlatButton label={locale.cancel(loc)}
              backgroundColor="#5a5a5a"
              style={{color: "#FFF"}}
              onClick={this.handleClose}
            />
          </Dialog>
        </MuiThemeProvider>
    )

  }
}


const mapStateToProps = state => ({
  server: state.server
});

const mapDispatchToProps = {
  deleteNode
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteButton);



// WEBPACK FOOTER //
// ./src/components/nodes/DeleteButton.js